import createReactComponent from '../createReactComponent';
export default createReactComponent('section-sign', 'IconSectionSign', [
  ['path', { d: 'M9.172 19a3 3 0 1 0 2.828 -4', key: 'svg-0' }],
  ['path', { d: 'M14.83 5a3 3 0 1 0 -2.83 4', key: 'svg-1' }],
  ['path', { d: 'M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0', key: 'svg-2' }],
]);
